import { FloatButton, Popover } from "antd";
import { iconSizeBigger } from "../../config";
import CloseIcon from "@ant-design/icons/CloseOutlined";
import { useDispatch, useSelector } from "react-redux";
import { closeInstructionHint } from "../../redux/ui/ui";
import { getInstructions } from "../../redux/selectors";
import { InstructionHintContent } from "../InstructionHintContent/InstructionHintContent";

function InstructionHint({ style }) {
  const instructions = useSelector(getInstructions);
  const { stage } = instructions ?? {};
  const dispatch = useDispatch();
  return stage !== undefined ? (
    <Popover
      open={true}
      content={<InstructionHintContent stage={stage} />}
      placement="topLeft"
      overlayClassName="hse-instruction-hint"
      color="#242423"
    >
      <FloatButton
        icon={<CloseIcon size={iconSizeBigger} />}
        style={style}
        onClick={() => dispatch(closeInstructionHint())}
      />
    </Popover>
  ) : null;
}

export default InstructionHint;
